import { useMutation } from '@gogame/query';

import { createConcept } from 'scenes/Gallery/GalleryPage/Concepts/sources/concepts';
import * as CREATIVE from 'scenes/Gallery/GalleryPage/Creatives/constants';
import { linkCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';
import { createCreative } from 'scenes/Gallery/GalleryPage/Creatives/sources/creatives';

import { create } from '../queryKeyFactory';

export const useCreate = () => {
  const handleCreateConcept = async (params) => {
    const { original, ...concept } = params;
    const { [CREATIVE.FILE_GUID]: fileGuid, ...restOriginal } = original;

    const { id: conceptId } = await createConcept(concept);
    const creativeGuid = await createCreative({
      ...restOriginal,
      [CREATIVE.CONCEPT_ID]: conceptId,
    });
    await linkCreative({ fileGuid, creativeGuid });

    return conceptId;
  };

  const createMutation = useMutation(create(), handleCreateConcept, {
    successMessage: (_data, variables) => {
      return `Concept «${variables.name}» created`;
    },
  });
  return [createMutation.mutateAsync, createMutation];
};
